import type { DefineComponent } from 'vue';

enum EManagerCompanyView {
  AGENCY = 'agency',
  USERS = 'users',
  AREAS = 'areas',
  SOURCES = 'sources',
  TOOLS = 'tools',
  MARKET_APPRAISALS = 'market-appraisals',
  UPLOAD_ADDRESSES = 'upload-addresses',
  STATS = 'stats',
  EXTERNAL_OFFICES = 'external-offices',
  OPPORTUNITY_LOOKUP = 'opportunity-lookup',
  MERGE = 'merge',
  GLOBAL_FILTERS = 'global-filters',
}

type TManagerCompanyPart = {
  key: EManagerCompanyView;
  label: string;
  requiresExternal?: boolean;
  excludeKeepAlive?: boolean;
};

// TODO: null to be removed after all views available
type TManagerCompanyViews = Record<EManagerCompanyView, DefineComponent | null>;

export type { TManagerCompanyPart, TManagerCompanyViews };

export { EManagerCompanyView };
